const CS571CloudConfig = {
    BADGERAUTH_API: "https://cs571.org/api",
    BADGERAUTH_UI_CENTER: "https://cs571.org/auth",
    CAPTCHA: "6LdoX_gnAAAAAGaseOd6ceFdGzWIO8YMPV9w3Daj",
    BASE: "",
    IS_ON_PREM: false
}

export default CS571CloudConfig;